jQuery(document).ready(function($) {

    $( ".bloc_paraphotos" ).each(function( index ) {

        let bloc = this

        // Cible : le slider, pour préserver le border-radius / overflow de .photos
        let cible = bloc.querySelector(".photos .slider") || bloc.querySelector(".photos")
        if (!cible) return

        // État initial : masqué, prêt à se révéler depuis la droite
        gsap.set(cible, { clipPath: "inset(0 0 0 100%)" })

        // Révélation au scroll — de droite à gauche
        gsap.to(cible, {
            clipPath: "inset(0 0 0 0%)",
            duration: 1.2,
            ease: "power3.out",
            scrollTrigger: {
                trigger: bloc,
                start: "top 80%"
            }
        })

    })

});
